
import { defineComponent } from "vue";
import RefreshingArrowsIcon from "@/components/icons/RefreshingArrowsIcon.vue";
import CarDetailsForSelection from "@/cars/CarDetailsForSelection.vue";
import { mapGetters } from "vuex";

interface SelectedCarData {
  isChangedCar: Boolean;
}

export default defineComponent({
  data(): SelectedCarData {
    return {
      isChangedCar: false,
    };
  },
  methods: {
    toggleChangeCar() {
      this.isChangedCar = !this.isChangedCar;
    },
    addNextCar() {
      this.$emit("selectNextCar");
    },
  },
  computed: {
    ...mapGetters("cars", ["getSelectedCar", "getCars", "getLimit"]),
  },
  components: {
    RefreshingArrowsIcon,
    CarDetailsForSelection,
  },
});
